<template>
    <transition name="modal">
        <div class="modal-mask" v-show="visible" @click.self="closeModal">
            <div class="modal-wrapper">
                <div class="modal-container" :style="{ width: modalWidth }">
                    <div class="modal-header">
                        <slot name="header">
                            <h3>{{ title }}</h3>
                        </slot>
                        <button class="modal-close" @click="closeModal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer" v-if="$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Modal Title'
        },
        modalWidth: {
            type: String,
            default: '50%'
        },
        closeOnOverlayClick: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        closeModal() {
            if (this.closeOnOverlayClick) {
                this.$emit('close');
            }
        }
    },
    watch: {
        visible(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    max-height: 80vh;
    overflow-y: auto;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.modal-header h3 {
    margin: 0;
}

.modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
}

.modal-body {
    margin: 20px 0;
}

.modal-footer {
    padding-top: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

/* Transition effects */
.modal-enter,
.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    transform: scale(1.1);
}
</style>